import UserAssitence from '../userAssistence';
import './style.scss';

function AssistenceItem({ groupData, deleteRecord }) {
  return (
    <div className='head-main-container'>
      <div className='descriptionHead-container'>
        <p className='number'>N°</p>
        <p className='name'>Nombre completo</p>
        <p className='assistence'>Asistencia</p>
        <p className='motive'>Motivo de inasistencia</p>
        <p className='notes'>Observaciones</p>
        <p className='actions'>Acciones</p>
      </div>
      {groupData.length > 0 &&
        groupData.map((user, i) => <UserAssitence key={i} i={i} user={user} deleteRecord={deleteRecord} />)}
    </div>
  );
}

export default AssistenceItem;
